import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faLocationDot } from '@fortawesome/pro-regular-svg-icons/faLocationDot';
import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons/faArrowsRotate';
import { useEducationalEventsContext } from '../../educational-events-context';
import { useEducationalEventFormat } from '../../helpers/use-educational-event-format';
import { isCurrentUserHost } from '../../helpers/event-view.helpers';
import styles from './events-sidebar.module.scss';

export function EventListItem({ event, isSelected, onSelect, ref }) {
  const { lang, userId } = useEducationalEventsContext();
  const { formatDateWithTime } = useEducationalEventFormat();
  const isHost = isCurrentUserHost({ event, userId });

  return (
    <button
      ref={ref}
      type="button"
      className={classNames(styles.item, { [styles.itemSelected]: isSelected })}
      onClick={onSelect}
      aria-current={isSelected ? 'true' : undefined}>
      <span className={styles.itemTitle}>
        {event.title}
        {event.scheduleEventGroupId && (
          <FontAwesomeIcon
            icon={faArrowsRotate}
            className={styles.recurringIcon}
            title={lang.RECURRING_EVENT}
            aria-label={lang.RECURRING_EVENT}
          />
        )}
      </span>
      <span className={styles.itemMeta}>
        <FontAwesomeIcon icon={faCalendar} className={styles.metaIcon} />
        {formatDateWithTime(event.startTime)}
        {event.location && (
          <>
            <span className={styles.metaSep}>|</span>
            <FontAwesomeIcon icon={faLocationDot} className={styles.metaIcon} />
            {event.location}
          </>
        )}
      </span>
      {isHost && <span className={styles.hostTag}>{lang.HOST}</span>}
    </button>
  );
}
